module.exports = __webpack_public_path__ + "static/auril-DND3_FnP-fb8f36bbb0a839281001b537c1a9f067.webp";